// OCT-7340: TreatyApp: User Management — add an Action History view of admin activity - Frontend : ashish.atwal@resolutionlife.com
// Data hook for the Action History drawer. Wraps the generated useActionHistoryQuery
// (backed by the OCT-7301 backend query), requesting a generous single page and
// exposing a simple bag of { entries, count, loading, error, retry }. All searching,
// filtering, sorting and counting happen client-side over the returned entries, so
// no server-side filter variables are needed here.
import {
  ActionHistoryEntryFragment,
  useActionHistoryQuery,
} from '../../graphql/generated';

// Matches the backend's maximum page size so a single request returns the full
// recent history for client-side filtering/sorting.
const PAGE_LIMIT = 200;

type UseActionHistoryBag = {
  loading: boolean;
  error: boolean;
  retry: () => void;
  entries: ActionHistoryEntryFragment[];
  count: number;
};

export const useActionHistory = (isOpen: boolean): UseActionHistoryBag => {
  const { data, loading, error, refetch } = useActionHistoryQuery({
    variables: { filter: { pagination: { limit: PAGE_LIMIT, offset: 0 } } },
    fetchPolicy: 'no-cache',
    nextFetchPolicy: 'no-cache',
    // Only fetch when the drawer is open.
    skip: !isOpen,
  });

  return {
    loading,
    error: !!error,
    retry: () => {
      refetch();
    },
    entries: data?.actionHistory?.entries ?? [],
    count: data?.actionHistory?.count ?? 0,
  };
};
